<script lang="ts">
</script>

<div class="container">
	<slot />
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		width: calc(100vw - 40px);
		max-width: 329px;
		background-color: #6d6f76;
		box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.1);
		padding: 25px;
		border-radius: 5px;
		box-sizing: border-box;
	}

	@include DesktopSize {
		.container {
			width: 337px;
			max-width: 337px;
			padding: 30px;
		}
	}

</style>
